import { KeycloakAdapter } from 'keycloak-js'
import { queryClient } from '#shared/api'
import { tgTokensQueryOptions } from '#shared/state/tg-tokens-query'
import keycloak from './keycloak'

const keycloakAdapter: KeycloakAdapter = {
  login: () => {
    throw new Error()
  },

  logout: () => {
    throw new Error()
  },

  register: () => {
    throw new Error()
  },

  accountManagement: () => {
    throw new Error()
  },

  redirectUri: () => {
    throw new Error()
  },
}

export default async function doTgLogin() {
  const authResponse = await queryClient.fetchQuery(tgTokensQueryOptions)

  await keycloak.init({
    token: authResponse.access_token,
    refreshToken: authResponse.refresh_token,
    checkLoginIframe: false,
    responseMode: 'query',
    adapter: keycloakAdapter,
  })
}
